import { render, staticRenderFns } from "./CityActivities.vue?vue&type=template&id=1a1176c9&"
import script from "./CityActivities.vue?vue&type=script&lang=js&"
export * from "./CityActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports